export const traceabilityEs = {
  title: 'Genealogía y trazabilidad de lotes',
  subtitle:
    'Rastrear lotes consumidos y producidos en todos los niveles y evaluar el impacto de una retirada.',
  help: { open: 'Abrir ayuda sobre genealogía de lotes y simulaciones de retirada' },
  tabs: { trace: 'Rastrear lotes', simulations: 'Simulaciones de retirada' },
  filters: {
    title: 'Filtros de trazabilidad',
    description:
      'Seleccione al menos un lote, artículo, socio u orden de producción. Todos los filtros están aislados por tenant.',
    batch: 'Lote',
    batchNumber: 'El número de lote contiene',
    product: 'Artículo',
    supplier: 'Proveedor',
    customer: 'Cliente',
    productionOrder: 'Orden de producción',
    from: 'Recepción desde',
    to: 'Recepción hasta',
    direction: 'Dirección',
    depth: 'Niveles máximos',
    any: 'Todos',
  },
  directions: {
    FORWARD: 'Hacia productos terminados',
    BACKWARD: 'Hacia materias primas',
    BOTH: 'Ambas direcciones',
  },
  relations: {
    ANCHOR: 'Lote inicial',
    UPSTREAM: 'Material anterior',
    DOWNSTREAM: 'Producto posterior',
    BOTH: 'Conectado en ambos sentidos',
  },
  batchStatuses: {
    FREE: 'Liberado',
    QUARANTINE: 'Cuarentena',
    BLOCKED: 'Bloqueado',
    EXPIRED: 'Caducado',
    DEPLETED: 'Agotado',
  },
  actions: {
    calculate: 'Ejecutar trazabilidad',
    reset: 'Restablecer filtros',
    createSimulation: 'Crear simulación de retirada',
    review: 'Revisar',
    cancel: 'Cancelar',
    confirmBlocks: 'Bloquear lotes afectados',
    export: 'Exportar CSV',
  },
  messages: {
    invalidFilter: 'Los filtros de trazabilidad están incompletos.',
    simulationCreated: 'Simulación creada desde una instantánea inmutable.',
    review: 'Simulación de retirada revisada.',
    cancel: 'Simulación de retirada cancelada.',
    blocksConfirmed: 'Se bloquearon los lotes afectados con existencias.',
  },
  warnings: {
    truncatedTitle: 'Límite de resultados alcanzado',
    truncated:
      'El grafo se truncó en la profundidad elegida o en el límite de seguridad. Acote los filtros o aumente la profundidad.',
  },
  stats: {
    lots: 'Lotes afectados',
    productionOrders: 'Órdenes de producción',
    deliveries: 'Entregas',
    customers: 'Clientes',
  },
  graph: {
    title: 'Flujo de materiales multinivel',
    description: 'Las flechas siguen el flujo desde los lotes consumidos hasta los producidos.',
    ariaLabel: 'Grafo de lotes anteriores y posteriores',
    snapshotTitle: 'Instantánea de genealogía congelada',
    snapshotDescription:
      'Este grafo coincide exactamente con la evidencia capturada al crear la simulación.',
  },
  impact: {
    title: 'Existencias, documentos y socios afectados',
    description: 'El impacto se deriva del conjunto completo de lotes rastreados.',
    inventory: 'Existencias disponibles',
    documents: 'Documentos y entregas',
    partners: 'Socios',
    productionOrders: 'Órdenes de producción',
    suppliers: 'Proveedores',
    customers: 'Clientes',
    snapshotTitle: 'Análisis de impacto congelado',
  },
  columns: {
    article: 'Artículo',
    batch: 'Lote',
    relation: 'Relación',
    status: 'Estado',
    warehouse: 'Almacén / ubicación',
    available: 'Disponible',
    document: 'Documento',
    type: 'Tipo',
    customer: 'Cliente',
    date: 'Fecha',
    batches: 'Lotes',
    productionOrder: 'Orden de producción',
    product: 'Producto',
    completed: 'Finalizado',
  },
  empty: {
    inventory: 'No hay existencias afectadas.',
    documents: 'No hay documentos afectados.',
    partners: 'No hay socios afectados.',
    orders: 'No hay órdenes de producción afectadas.',
    trace: 'Elija filtros para mostrar la genealogía de lotes.',
    simulations: 'No se encontraron simulaciones de retirada.',
    selectSimulation: 'Seleccione una simulación de retirada.',
  },
  simulations: {
    search: 'Buscar número, título o motivo',
    allStatuses: 'Todos los estados',
    title: 'Simulaciones guardadas',
    description: 'Cada entrada conserva su grafo, impacto, filtros y prueba SHA-256.',
    noNotificationTitle: 'Sin notificación externa',
    noNotification:
      'Este flujo no avisa a clientes, proveedores ni autoridades. La comunicación externa requiere una acción separada, explícita y autorizada.',
  },
  statuses: {
    DRAFT: 'Borrador',
    REVIEWED: 'Revisada',
    BLOCKS_CONFIRMED: 'Lotes bloqueados',
    CANCELLED: 'Cancelada',
  },
  fields: {
    title: 'Título',
    reason: 'Motivo',
    note: 'Nota de decisión',
    createdAt: 'Creada',
    direction: 'Dirección de trazabilidad',
    snapshotHash: 'SHA-256 de la instantánea',
    blockedBatches: 'Lotes bloqueados',
  },
  create: {
    title: 'Crear simulación de retirada',
    description:
      'El grafo y el impacto actuales se congelan como instantánea inmutable. Aún no se bloquea ningún lote.',
  },
  workflow: {
    review: {
      title: 'Revisar simulación de retirada',
      description:
        'Confirme que el impacto congelado se ha comprobado con la evidencia disponible.',
    },
    cancel: {
      title: 'Cancelar simulación de retirada',
      description:
        'La instantánea permanece disponible para auditoría; no se cambiarán los lotes afectados.',
    },
  },
  block: {
    title: 'Bloquear explícitamente los lotes afectados',
    description:
      'Se evaluarán y bloquearán transaccionalmente {{count}} lote(s) afectado(s) con existencias.',
    notificationTitle: 'Se excluye la comunicación externa',
    notificationDescription:
      'El bloqueo de existencias no envía correos, mensajes ni avisos regulatorios.',
    confirmLots:
      'Confirmo explícitamente que deben bloquearse todos los lotes afectados con existencias.',
    confirmNoNotification: 'Entiendo que esta acción no envía ninguna notificación externa.',
  },
} as const;
